import { render } from "./BancaDatiSearchParams.vue?vue&type=template&id=9b810e70"
import script from "./BancaDatiSearchParams.vue?vue&type=script&lang=ts"
export * from "./BancaDatiSearchParams.vue?vue&type=script&lang=ts"
script.render = render

export default script